import { createFileRoute, Link, Outlet } from "@tanstack/react-router";
import { Bell, Globe2, ImageIcon } from "lucide-react";

export const Route = createFileRoute("/_authenticated/settings")({
  component: SettingsLayout,
});

const SETTINGS_NAV = [
  { to: "/settings/profile-images", label: "Profile & cover images", icon: ImageIcon },
  { to: "/settings/notifications", label: "Notifications", icon: Bell },
  { to: "/settings/region", label: "Language & region", icon: Globe2 },
] as const;

function SettingsLayout() {
  return (
    <div className="border-t border-border/60">
      <div className="mx-auto max-w-5xl px-4 pt-8 sm:px-6">
        <nav aria-label="Account settings" className="flex flex-wrap gap-2">
          {SETTINGS_NAV.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              activeProps={{ className: "border-primary bg-primary/10 text-foreground" }}
              className="flex items-center gap-2 rounded-full border border-border/70 px-4 py-2 text-sm text-muted-foreground transition-smooth hover:text-foreground"
            >
              <item.icon className="h-4 w-4" aria-hidden="true" />
              {item.label}
            </Link>
          ))}
        </nav>
      </div>
      <Outlet />
    </div>
  );
}
